import { useEffect, useState } from 'react';
import { Card, CardBody, Container, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import BetterBreadcrumb from 'src/components/Common/BetterBreadCrumb';
import MiniCexFormA from './MiniCexFormA';
import MiniCexFormB from './MiniCexFormB';
import { useParams } from 'react-router-dom';
import MiniCexFormBInformation from './MiniCexFormBInformation';
import { useLazyGetSessionWiseMiniCexListQuery } from 'src/rtk/features/miniCexCBD/miniCexAndCBDApi';
import MiniCexFormAInformation from './MiniCexFormAInformation';

const MiniCEXFormDetails = () => {
    const { regNo: registrationNo, logbookSessionId: sessionId } = useParams<{
        regNo: string;
        logbookSessionId: string;
    }>();

    const [getSessionWiseMiniCexList, { data: list }] = useLazyGetSessionWiseMiniCexListQuery();

    useEffect(() => {
        getSessionWiseMiniCexList(registrationNo);
    }, [list]);

    const formEntryList = list?.data?.find((item: any) => { return item?.logbook_entry_session_id === sessionId});
    // console.log(formEntryList);
    
    const [activeTab, setActiveTab] = useState('formA');
    
    const toggleTab = (tab: string) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    return (
        <div className="page-content">
            <Container fluid>
                <BetterBreadcrumb
                    breadcrumbItem={[{ link: '#', name: 'Assessment' },{ link: '/mini-cex-list', name: 'Mini-CEX List' }]}
                    title={'Mini-CEX Form Details'}
                />
                <Card>
                    <CardBody>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    className={activeTab === 'formA' ? 'active' : ''}
                                    onClick={() => toggleTab('formA')}
                                >
                                    Form A Details
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={activeTab === 'formB' ? 'active' : ''}
                                    onClick={() => toggleTab('formB')}
                                >
                                    Form B Details
                                </NavLink>
                            </NavItem>
                        </Nav>

                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="formA">
                                <MiniCexFormAInformation formEntryList={formEntryList}/>
                            </TabPane>
                            <TabPane tabId="formB">
                                <MiniCexFormBInformation formEntryList={formEntryList}/>
                            </TabPane>
                        </TabContent>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default MiniCEXFormDetails;
